import InnerWithdrawRequestTable from './InnerWithdrawRequestTable';

export default InnerWithdrawRequestTable;
